<script setup lang="ts">
import { Toast, ToastItemType } from './toast';


</script>


<template>

    <div
        class="toast"
        v-if="Toast.items.length > 0"
    >

        <div
            v-for="item in Toast.items"
            :key="item.id"
            class="toast-item"
            :class="{'toast-item-show': item.show, 'toast-item-success': item.type == ToastItemType.SUCCESS, 'toast-item-error': item.type == ToastItemType.ERROR}"
        >

            <div class="toast-item-content">
                <div class="toast-item-content-title">{{ item.title }}</div>
                <!-- <div class="toast-item-content-text">{{ item.value }}</div> -->
                <div class="toast-item-content-text" v-html="item.value"></div>
            </div>

            <div class="toast-item-actions">
                <div
                    class="toast-item-actions-close"
                    @click="Toast.remove(item.id)"
                >
                    <svg class="toast-item-actions-close-svg" viewBox="0 0 320 512"><path d="M312.1 375c9.369 9.369 9.369 24.57 0 33.94s-24.57 9.369-33.94 0L160 289.9l-119 119c-9.369 9.369-24.57 9.369-33.94 0s-9.369-24.57 0-33.94L126.1 256L7.027 136.1c-9.369-9.369-9.369-24.57 0-33.94s24.57-9.369 33.94 0L160 222.1l119-119c9.369-9.369 24.57-9.369 33.94 0s9.369 24.57 0 33.94L193.9 256L312.1 375z"/></svg>
                </div>
            </div>

        </div>

    </div>

</template>


<style lang="scss" scoped>

    @use './toast.scss';

</style>